import React, { Component } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { reloadRoadmapPosts } from 'common/actions/roadmapPosts';
import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { OpenModalContext } from 'common/containers/ModalContainer';
import { LocationContext, ParamsContext } from 'common/containers/RouterContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import LazyLoadedImage from 'common/LazyLoadedImage';
import AccessModal from 'common/modals/AccessModal';
import AdminCreateLinearIssueModal from 'common/subdomain/admin/AdminCreateLinearIssueModal';
import Tappable from 'common/Tappable';
import { getQueryFilterParams } from 'common/util/filterPosts';
import hasPermission from 'common/util/hasPermission';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';
import withContexts from 'common/util/withContexts';
import LinearLogoIcon from 'img/landing/linear-logo.webp';

import AdminCreateAsanaTaskModal from '../../AdminCreateAsanaTaskModal';
import AdminCreateAzureDevopsWorkItemModal from '../../AdminCreateAzureDevopsWorkItemModal';
import AdminCreateClickupTaskModal from '../../AdminCreateClickupTaskModal';
import AdminCreateGithubIssueModal from '../../AdminCreateGithubIssueModal';
import AdminCreateJiraIssueModal from '../../AdminCreateJiraIssueModal';

import 'css/components/subdomain/admin/AdminRoadmap/_AdminRoadmapPostIntegrations.scss';

import AsanaLogoIcon from 'img/asana-logo.png';
import AzureDevopsLogoIcon from 'img/azure-devops-logo.png';
import ClickupLogoIcon from 'img/clickup-logo.png';
import GithubLogoIcon from 'img/github-logo-icon.png';
import JiraLogoIcon from 'img/jira-logo.svg';

const Modals = {
  Asana: 'Asana',
  AzureDevops: 'AzureDevops',
  Clickup: 'Clickup',
  Github: 'Github',
  Jira: 'Jira',
  Linear: 'Linear',
};

class AdminRoadmapPostIntegrations extends Component {
  static propTypes = {
    boards: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        urlName: PropTypes.string,
      }),
    ),
    company: PropTypes.shape({
      clickup: PropTypes.shape({
        authorized: PropTypes.bool,
      }),
      jira: PropTypes.shape({
        connected: PropTypes.bool,
      }),
    }),
    post: PropTypes.shape({
      _id: PropTypes.string,
      title: PropTypes.string,
      urlName: PropTypes.string,
      status: PropTypes.string,
    }),
    roadmap: PropTypes.shape({
      _id: PropTypes.string,
    }),
    viewer: PropTypes.shape({
      _id: PropTypes.string,
    }),
  };

  state = {
    modal: null,
    error: null,
    creatingResource: false,
  };

  pushToAsana = () => {
    const { company, openModal, viewer } = this.props;

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    this.setState({ modal: Modals.Asana, error: null, creatingResource: false });
  };

  pushToAzureDevops = () => {
    const { company, openModal, viewer } = this.props;

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    this.setState({ modal: Modals.AzureDevops, error: null, creatingResource: false });
  };

  pushToClickup = () => {
    const { company, openModal, viewer } = this.props;

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    this.setState({ modal: Modals.Clickup, error: null, creatingResource: false });
  };

  pushToGithub = () => {
    const {
      boards,
      company,
      location,
      openModal,
      params,
      post,
      reloadRoadmapPosts,
      roadmap,
      viewer,
    } = this.props;
    const board = boards.find((board) => post.boardID === board._id);

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    const boardInQuery = boards.find((board) => board.urlName === params.boardURLName);
    const queryParams = getQueryFilterParams(boardInQuery, company, location, {}, roadmap);

    openModal(AdminCreateGithubIssueModal, {
      board,
      onIssueCreated: () => reloadRoadmapPosts(queryParams),
      post,
    });
  };

  pushToJira = () => {
    const { company, openModal, viewer } = this.props;

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    this.setState({ modal: Modals.Jira, error: null, creatingResource: false });
  };

  pushToLinear = () => {
    const { company, openModal, viewer } = this.props;

    if (!hasPermission('manageRoadmap', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['manageRoadmap'],
      });
      return;
    }

    this.setState({ modal: Modals.Linear, error: null, creatingResource: false });
  };

  onCreateClickupTask = async ({ description, listID, name }) => {
    const { boards, company, location, params, post, reloadRoadmapPosts, roadmap } = this.props;

    this.setState({ error: null, creatingResource: true });

    const response = await AJAX.post('/api/clickup/createAndLink', {
      postID: post._id,
      description,
      listID,
      name,
    });

    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
    });

    if (error) {
      this.setState({ error: error.message, creatingResource: false });
      return;
    }

    const boardInQuery = boards.find((board) => board.urlName === params.boardURLName);
    const queryParams = getQueryFilterParams(boardInQuery, company, location, {}, roadmap);

    await reloadRoadmapPosts(queryParams);

    this.setState({ creatingResource: false });
    this.closeModal();
  };

  onCreateJiraIssue = async (issueData) => {
    const { boards, company, location, params, post, reloadRoadmapPosts, roadmap } = this.props;

    this.setState({ error: null, creatingResource: true });

    const response = await AJAX.post('/api/jira/createAndLinkIssue', {
      customValues: issueData.customValues,
      jiraProjectID: issueData.projectID,
      jiraIssueTypeID: issueData.issueTypeID,
      issueDescription: issueData.description,
      issueSummary: issueData.summary,
      postID: post._id,
    });

    const { error, parsedResponse } = parseAPIResponse(response, {
      isSuccessful: (parsedResponse) => parsedResponse?.issue,
    });

    if (error) {
      this.setState({ error: error.message, creatingResource: false });
      return;
    }

    // open new issue in a new tab
    // if popups are blocked by the browser, `issueWindow` will be `null`
    const { issue } = parsedResponse;
    const issueWindow = window.open(issue.url, '_blank', 'noopener');
    issueWindow?.focus();

    const boardInQuery = boards.find((board) => board.urlName === params.boardURLName);
    const queryParams = getQueryFilterParams(boardInQuery, company, location, {}, roadmap);

    await reloadRoadmapPosts(queryParams);

    this.setState({ creatingResource: false });
    this.closeModal();
  };

  onCreateLinearIssue = async ({ description, stateID, teamID, title }) => {
    const { boards, company, location, params, post, reloadRoadmapPosts, roadmap } = this.props;

    this.setState({ error: null, creatingResource: true });

    const response = await AJAX.post('/api/linear/createAndLinkIssue', {
      description,
      postID: post._id,
      stateID,
      teamID,
      title,
    });

    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
    });

    if (error) {
      this.setState({ error: error.message, creatingResource: false });
      return;
    }

    const boardInQuery = boards.find((board) => board.urlName === params.boardURLName);
    const queryParams = getQueryFilterParams(boardInQuery, company, location, {}, roadmap);

    await reloadRoadmapPosts(queryParams);

    this.setState({ creatingResource: false });
    this.closeModal();
  };

  closeModal = () => {
    this.setState({ modal: null });
  };

  renderAsanaIntegration = () => {
    const { company, post } = this.props;
    if (!company?.activeIntegrations?.asana) {
      return null;
    }

    const isLinked = !!post.asanaTasks?.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={AsanaLogoIcon}
        alt="Asana Logo"
      />
    );

    if (isLinked) {
      const [firstTask] = post.asanaTasks;
      return (
        <div className="integrationIcon">
          <a href={firstTask.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToAsana}>{icon}</Tappable>
      </div>
    );
  };

  renderAzureDevopsIntegration = () => {
    const { company, post } = this.props;
    if (!company?.activeIntegrations?.azureDevops) {
      return null;
    }

    const isLinked = !!post.azureDevopsWorkItems?.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={AzureDevopsLogoIcon}
        alt="Azure DevOps Logo"
      />
    );

    if (isLinked) {
      const [workItem] = post.azureDevopsWorkItems;
      return (
        <div className="integrationIcon">
          <a href={workItem.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToAzureDevops}>{icon}</Tappable>
      </div>
    );
  };

  renderClickupIntegration = () => {
    const {
      company: { clickup },
      post,
    } = this.props;
    if (!clickup?.authorized) {
      return null;
    }

    const isLinked = !!post.clickupTasks?.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={ClickupLogoIcon}
        alt="ClickUp Logo"
      />
    );

    if (isLinked) {
      const [firstTask] = post.clickupTasks;
      return (
        <div className="integrationIcon">
          <a href={firstTask.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToClickup}>{icon}</Tappable>
      </div>
    );
  };

  renderGithubIntegration = () => {
    const {
      company: { github },
      post,
    } = this.props;
    if (!github?.installationID) {
      return null;
    }

    const isLinked = !!post.githubIssues.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={GithubLogoIcon}
        alt="Github Logo"
      />
    );

    if (isLinked) {
      const [firstIssue] = post.githubIssues;
      return (
        <div className="integrationIcon">
          <a href={firstIssue.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToGithub}>{icon}</Tappable>
      </div>
    );
  };

  renderJiraIntegration = () => {
    const {
      company: { jira },
      post,
    } = this.props;
    if (!jira?.connected) {
      return null;
    }

    const isLinked = !!post.jiraIssues.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={JiraLogoIcon}
        alt="Jira Logo"
      />
    );

    if (isLinked) {
      const [firstIssue] = post.jiraIssues;
      return (
        <div className="integrationIcon">
          <a href={firstIssue.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToJira}>{icon}</Tappable>
      </div>
    );
  };

  renderLinearIntegration = () => {
    const { company, post } = this.props;
    if (!company?.activeIntegrations?.linear) {
      return null;
    }

    const isLinked = !!post.linearIssues?.length;
    const icon = (
      <LazyLoadedImage
        className={classnames('logo', { linked: isLinked })}
        src={LinearLogoIcon}
        alt="Linear Logo"
      />
    );

    if (isLinked) {
      const [firstIssue] = post.linearIssues;
      return (
        <div className="integrationIcon">
          <a href={firstIssue.url} rel="noopener" target="_blank">
            {icon}
          </a>
        </div>
      );
    }

    return (
      <div className="integrationIcon">
        <Tappable onTap={this.pushToLinear}>{icon}</Tappable>
      </div>
    );
  };

  renderModals = () => {
    const { boards, company, location, params, post, reloadRoadmapPosts, roadmap } = this.props;
    const { creatingResource, error, modal } = this.state;
    const board = boards.find((board) => post.boardID === board._id);

    const boardInQuery = boards.find((board) => board.urlName === params.boardURLName);
    const queryParams = getQueryFilterParams(boardInQuery, company, location, {}, roadmap);

    const ModalComponent = {
      [Modals.Asana]: (
        <AdminCreateAsanaTaskModal
          onClose={this.closeModal}
          onTaskCreated={() => reloadRoadmapPosts(queryParams)}
          post={{ ...post, board }}
        />
      ),
      [Modals.AzureDevops]: (
        <AdminCreateAzureDevopsWorkItemModal
          onClose={this.closeModal}
          onWorkItemCreated={() => reloadRoadmapPosts(queryParams)}
          post={{ ...post, board }}
        />
      ),
      [Modals.Clickup]: (
        <AdminCreateClickupTaskModal
          creating={creatingResource}
          error={error}
          title={post.title}
          description={post.description}
          imageURLs={post.imageURLs}
          onClose={this.closeModal}
          onCreate={this.onCreateClickupTask}
        />
      ),
      [Modals.Jira]: (
        <AdminCreateJiraIssueModal
          creating={creatingResource}
          error={error}
          title={post.title}
          description={post.details}
          onClose={this.closeModal}
          onCreate={this.onCreateJiraIssue}
        />
      ),
      [Modals.Linear]: (
        <AdminCreateLinearIssueModal
          creating={creatingResource}
          error={error}
          title={post.title}
          description={post.details}
          onClose={this.closeModal}
          onCreate={this.onCreateLinearIssue}
        />
      ),
    }[modal];

    return ModalComponent ?? null;
  };

  render() {
    return (
      <div className="adminRoadmapPostIntegrations">
        {this.renderAsanaIntegration()}
        {this.renderAzureDevopsIntegration()}
        {this.renderClickupIntegration()}
        {this.renderJiraIntegration()}
        {this.renderGithubIntegration()}
        {this.renderLinearIntegration()}
        {this.renderModals()}
      </div>
    );
  }
}

export default compose(
  connect(null, { reloadRoadmapPosts }),
  withContexts(
    {
      company: CompanyContext,
      location: LocationContext,
      openModal: OpenModalContext,
      params: ParamsContext,
      viewer: ViewerContext,
    },
    { forwardRef: true },
  ),
)(AdminRoadmapPostIntegrations);
